requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xBadges', {
      fixedPositionTemplate: `<div
        class="x-badge-{label-id} x-badge-container pointer-events-none{container-img-class} ltr"
        {preview-show-condition}
      >
        {content}
      </div>`,
      customPositionTemplate: `<div
        class="x-badge-{label-id} x-badge-container min-w-fit max-w-full max-h-full pointer-events-none{container-css-class} ltr"
        x-data="{
          contentHeight: 1,
          rePosition() {
            this.$nextTick(() => {
              this.contentHeight = this.$refs.content ? this.$refs.content.offsetHeight : contentHeight;
            });
          }
        }"
        x-intersect.once="rePosition();
          if (Shopify.designMode) {
            window.addEventListener('resize', () => {
              if ($store.xBadges.lastWindowWidth != window.innerWidth) {
                rePosition();
              }
            });
          } else {
            installMediaQueryWatcher('(min-width: 768px)', (matches) => rePosition());
          }"
        {preview-show-condition}
        :style="'{css-position} min-height: ' + contentHeight + 'px'"
      >
        {content}
      </div>`,
      productDetailTemplate: `<div
        class="x-badge-{label-id} x-badge-container min-w-fit max-w-full max-h-full bottom-0 pointer-events-none{container-css-class}{container-img-class}"
      >
        {content}
      </div>`,
      outSideImageTemplate: `<div class="hidden" 
        x-data="{
          setPosition() {
            const element = $el.closest('.card-product').getElementsByClassName('{queryEL}');
            for (let i = 0; i < element.length; i++) {
              element[i].innerHTML += $el.innerHTML;
            }
          }
        }"
        x-init="setPosition()">
        <div
          class="x-badge-{label-id} x-badge-container min-w-fit max-w-full max-h-full bottom-0 pointer-events-none{container-img-class}"
          {preview-show-condition}
        >
          {content}
        </div>
      </div>`,
      previewActiveBlock: window.xBadgesPreviewActiveBlock,
      init() {
        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            if (!event.target.classList.contains('x-badges-block-preview')) return;

            let blockId = event.target.getAttribute('block-id');
            this.previewActiveBlock = blockId;
            window.xBadgesPreviewActiveBlock = blockId;
            document.dispatchEvent(new CustomEvent("eurus:badges:block-select"));
          });
        }
      },
      load(el, callback = () => {}, container = null, productCard = false) {
        if (container) el.container = container;

        const sliderEl = el.closest('[x-data-slider]');
        if (sliderEl) {
          if (!sliderEl.classList.contains('is-initialized')) {
            const sectionId = el.closest('[x-data-slider]').getAttribute('x-data-slider');
            document.addEventListener(`eurus:${sectionId}:splide-ready`, () => {
              this.doLoad(el, productCard, callback);
            });
          } else {
            this.doLoad(el, productCard, callback);
          }
        } else {
          this.doLoad(el, productCard, callback);
        }
      },
      doLoad(el, productCard, callback = () => {}) {
        this.initAllLabels(el, productCard);

        if (Shopify.designMode) {
          let productData = xParseJSON(el.getAttribute('x-labels-data'));
          document.addEventListener('shopify:section:load', () => {
            if (productData && !productData.isXBadgesPreview) {
              this.initAllLabels(el, productCard);
            }
          });
        }

        callback(el);
      },
      initAllLabels(el, productCard) {
        let productDatas = xParseJSON(el.getAttribute('x-labels-data'));
        let allLabels = document.getElementsByClassName('x-badges-block-data');

        if (!productDatas) return;

        if (Shopify.designMode || productCard) {
          const cardProduct = el.closest('.card-product');
          if (cardProduct) {
            let currentLabels = cardProduct.getElementsByClassName('x-badge-container');
            while (currentLabels?.length > 0) {
              currentLabels[0].remove();
            }
            // Also remove custom badge containers
            let customContainers = cardProduct.getElementsByClassName('custom-badge-container');
            while (customContainers?.length > 0) {
              customContainers[0].remove();
            }
          }  
        }

        if (productCard) {
          requestAnimationFrame(() => {
            let variantId = null;
            const variantEl = el.closest('.card-product')?.querySelector(".current-variant");

            if (variantEl) {
              try {
                const currentVariant = JSON.parse(el.closest('.card-product')?.querySelector(".current-variant")?.textContent);
                variantId = (typeof currentVariant === 'object') ? currentVariant.id : currentVariant;
              } catch (e) {
                variantId = null;
              }
            }
            
            if (variantId) {
              const selectedVariant = productDatas.find(productData => productData.variant_id === Number(variantId));
              
              if (selectedVariant) {
                // Check for backorder tags before showing "In Stock" badge
                let hasBackorderTag = false;
                if (selectedVariant.metafield_label) {
                  const metafieldValues = [];
                  Object.entries(selectedVariant.metafield_label).forEach(([key, value]) => {
                    if (value && value.trim() !== '') {
                      const values = value.split(',').map(v => v.trim()).filter(v => v !== '');
                      metafieldValues.push(...values);
                    }
                  });
                  
                  // Check if any metafield value matches backorder indicators
                  hasBackorderTag = metafieldValues.some(value => 
                    value === 'Backorder' || value === 'Custom Order' || value === 'Preorder'
                  );
                }
                
                // Only show "In Stock" badge if variant is available, (has stock OR continue selling), AND no backorder tags
                const isAvailable = selectedVariant.variant_available || selectedVariant.available;
                const hasStock = selectedVariant.qty > 0 || selectedVariant.inventory_policy === 'continue';
                if (isAvailable && hasStock && !hasBackorderTag) {
                  let inStockLabel;
                  if (allLabels.length > 0) {
                    const firstLabel = xParseJSON(allLabels[0].getAttribute('x-badges-block-data'));
                    inStockLabel = { ...firstLabel };
                  } else {
                    // Create default In Stock badge when no badge blocks exist
                    inStockLabel = {
                      id: 'in-stock-fallback',
                      enable: true,
                      settings: {
                        size: 2,
                        size_mobile: 2,
                        opacity: 100,
                        position: 'custom',
                        show_on_product_page: true,
                        show_on_product_card: true
                      }
                    };
                  }
                  inStockLabel._metafieldValue = 'In Stock';
                  inStockLabel._isInStockBadge = true;
                  inStockLabel.id = 'in_stock_' + selectedVariant.variant_id;
                  inStockLabel.settings.icon = '';
                  this.appendLabel(el, inStockLabel, selectedVariant);
                }
                
                for (let i = 0;i < allLabels.length;i++) {
                  let label = xParseJSON(allLabels[i].getAttribute('x-badges-block-data'));
                  if (!label.enable && !selectedVariant.isXBadgesPreview) continue;
                  
                  label.settings.icon = allLabels[i].getAttribute('x-badges-icon');
                  
                  if (this.shouldApplyBadgeToVariant(label, selectedVariant)) {
                    // Check if this label should create multiple metafield badges
                    if (selectedVariant.metafield_label && this.canShow(label, selectedVariant)) {
                      const metafieldValues = [];
                      Object.entries(selectedVariant.metafield_label).forEach(([key, value]) => {
                        if (value && value.trim() !== '') {
                          const values = value.split(',').map(v => v.trim()).filter(v => v !== '');
                          metafieldValues.push(...values);
                        }
                      });
                      
                      if (metafieldValues.length > 1) {
                        // Create separate badges for each metafield value
                        metafieldValues.forEach((value, index) => {
                          const modifiedLabel = { ...label };
                          modifiedLabel._metafieldValue = value;
                          modifiedLabel._isMetafieldBadge = true;
                          modifiedLabel.id = label.id + '_metafield_' + index;
                          this.appendLabel(el, modifiedLabel, selectedVariant);
                        });
                        
                        return; // Skip the normal appendLabel call
                      }
                    }
                    
                    this.appendLabel(el, label, selectedVariant);
                  }
                }  
              }
            } else {
              // No specific variant selected, use first variant
              const firstVariant = productDatas[0];
              
              // Check for backorder tags before showing "In Stock" badge for first variant
              let hasBackorderTag = false;
              if (firstVariant.metafield_label) {
                const metafieldValues = [];
                Object.entries(firstVariant.metafield_label).forEach(([key, value]) => {
                  if (value && value.trim() !== '') {
                    const values = value.split(',').map(v => v.trim()).filter(v => v !== '');
                    metafieldValues.push(...values);
                  }
                });
                
                // Check if any metafield value matches backorder indicators
                hasBackorderTag = metafieldValues.some(value => 
                  value === 'Backorder' || value === 'Custom Order' || value === 'Preorder'
                );
              }
              
              // Only show "In Stock" badge if variant is available, (has stock OR continue selling), AND no backorder tags
              const isAvailable = firstVariant.variant_available || firstVariant.available;
              const hasStock = firstVariant.qty > 0 || firstVariant.inventory_policy === 'continue';
              if (isAvailable && hasStock && !hasBackorderTag) {
                let inStockLabel;
                if (allLabels.length > 0) {
                  const firstLabel = xParseJSON(allLabels[0].getAttribute('x-badges-block-data'));
                  inStockLabel = { ...firstLabel };
                } else {
                  // Create default In Stock badge when no badge blocks exist
                  inStockLabel = {
                    id: 'in-stock-fallback',
                    enable: true,
                    settings: {
                      size: 2,
                      size_mobile: 2,
                      opacity: 100,
                      position: 'custom',
                      show_on_product_page: true,
                      show_on_product_card: true
                    }
                  };
                }
                inStockLabel._metafieldValue = 'In Stock';
                inStockLabel._isInStockBadge = true;
                inStockLabel.id = 'in_stock_' + firstVariant.variant_id;
                inStockLabel.settings.icon = '';
                this.appendLabel(el, inStockLabel, firstVariant);
              }
              
              for (let i = 0;i < allLabels.length;i++) {
                let label = xParseJSON(allLabels[i].getAttribute('x-badges-block-data'));
                if (!label.enable && !productDatas[0].isXBadgesPreview) return;
                
                label.settings.icon = allLabels[i].getAttribute('x-badges-icon');
                
                this.appendLabel(el, label, productDatas[0]);
              }  
            }
          });
        } else {
          // Check for backorder tags before showing "In Stock" badge for single product data
          let hasBackorderTag = false;
          if (productDatas.metafield_label) {
            const metafieldValues = [];
            Object.entries(productDatas.metafield_label).forEach(([key, value]) => {
              if (value && value.trim() !== '') {
                const values = value.split(',').map(v => v.trim()).filter(v => v !== '');
                metafieldValues.push(...values);
              }
            });
            
            // Check if any metafield value matches backorder indicators
            hasBackorderTag = metafieldValues.some(value => 
              value === 'Backorder' || value === 'Custom Order' || value === 'Preorder'
            );
          }
          
          // Only show "In Stock" badge if product is available, (has stock OR continue selling), AND no backorder tags
          const isAvailable = productDatas.available;
          const hasStock = productDatas.qty > 0 || productDatas.inventory_policy === 'continue';
          if (isAvailable && hasStock && !hasBackorderTag) {
            let inStockLabel;
            if (allLabels.length > 0) {
              const firstLabel = xParseJSON(allLabels[0].getAttribute('x-badges-block-data'));
              inStockLabel = { ...firstLabel };
            } else {
              // Create default In Stock badge when no badge blocks exist
              inStockLabel = {
                id: 'in-stock-fallback',
                enable: true,
                settings: {
                  size: 2,
                  size_mobile: 2,
                  opacity: 100,
                  position: 'custom',
                  show_on_product_page: true,
                  show_on_product_card: true
                }
              };
            }
            inStockLabel._metafieldValue = 'In Stock';
            inStockLabel._isInStockBadge = true;
            inStockLabel.id = 'in_stock_' + productDatas.variant_id;
            inStockLabel.settings.icon = '';
            this.appendLabel(el, inStockLabel, productDatas);
          }
          
          for (let i = 0;i < allLabels.length;i++) {
            let label = xParseJSON(allLabels[i].getAttribute('x-badges-block-data'));
            if (!label.enable && !productDatas.isXBadgesPreview) return;
            
            label.settings.icon = allLabels[i].getAttribute('x-badges-icon');
            
            this.appendLabel(el, label, productDatas);
          }  

          el.removeAttribute('x-labels-data');
        }
      },
      appendLabel(el, label, productData) {
        const processedTemplate = this.processTemplate(el, label, productData);
        
        if (productData.container == 'product-info') {
          el.innerHTML += processedTemplate;
          return;
        }
        
        if (label.settings.position == 'custom') {
          // Create or find custom badge container for proper vertical stacking
          let customContainer = el.querySelector('.custom-badge-container');
          if (!customContainer) {
            customContainer = document.createElement('div');
            customContainer.setAttribute('class', 'custom-badge-container absolute top-2 left-2 flex flex-col gap-1 pointer-events-none z-20');
            el.appendChild(customContainer);
          }
          customContainer.innerHTML += processedTemplate;
          return;
        }

        let container = el.querySelector(`.${label.settings.position}-container`);
        
        if (!container) {
          container = this.createFixedPositionContainer(label.settings.position);
          el.appendChild(container);
        }

        let labelHTML = processedTemplate;
        
        let tempDiv = document.createElement('div');
        tempDiv.innerHTML = labelHTML;
        let newLabelText = tempDiv.textContent.trim().toLowerCase();
        
        container.querySelectorAll('.x-badge-content').forEach(existing => {
          let existingText = existing.textContent.trim().toLowerCase();
          if (existingText && existingText === newLabelText) {
            existing.parentNode.removeChild(existing);
          }
        });

        container.innerHTML += labelHTML;
      },
      createFixedPositionContainer(position) {
        let HTMLClass = `${position}-container label-container absolute gap-1 space-y-1`;
        HTMLClass += position.includes('top') ? ' top-1 flex-col' : ' bottom-1 flex-col-reverse';
        HTMLClass += position.includes('left') ? ' left-1' : ' right-1';

        container = document.createElement("div");
        container.setAttribute('class', HTMLClass);

        return container;
      },
      processContent(el, label, productData) {
        let content = false;
        const canShow = this.canShow(label, productData);

        if (label.settings.image && canShow) {
          let imageHeight, imageWidth;
          if (productData.container == 'product-info') {
            imageHeight = 126;
            imageWidth = Math.round(imageHeight * label.settings.image_aspect_ratio);
          } else {
            imageWidth = label.settings.size_mobile > label.settings.size ? label.settings.size_mobile * 15 : label.settings.size * 15;
            imageHeight = imageWidth / label.settings.image_aspect_ratio;
          }
          let image;
          if (label.settings.image.src) {
            image = label.settings.image.src.includes('burst.shopifycdn.com') ? label.settings.image.src : 
            label.settings.image.src + `&width=` + (imageWidth * 3);
          } else {
            image = label.settings.image.includes('burst.shopifycdn.com') ? label.settings.image : 
            label.settings.image + `&width=` + (imageWidth * 3);
          }
          if (productData.container == "card") {
            var imageDirection = label.settings.position.includes('left') ? "justify-start" : "justify-end";
            var styleImage = 'width: var(--width-image-label); height: var(--height-image-label)';
          } else {
            var imageDirection = productData.make_content_center ? "justify-center" : "justify-start";
            var styleImage = '';
          }
          content = `<div x-ref="content" class='x-badge-content flex ${imageDirection}{css-opacity}'>
            <img 
              loading="lazy"
              width="` + imageWidth + `"
              height="` + imageHeight + `"
              alt="` + (label.settings.image_alt.length > 0 ? label.settings.image_alt : productData.title) + `"
              src="` + image + `"
              style="${styleImage}"
            />
          </div>`;
        } else if (label._isInStockBadge && canShow) {
          // Create "In Stock" badge
          const badgeText = label._metafieldValue;
          const tagClass = 'p-tag g-tag-in-stock';
          
          const padding = (label.settings?.size || 2) / 2;
          const padding_mobile = (label.settings?.size_mobile || 2) / 2;
          const sizeClass = productData.container == 'product-info' 
            ? ` py-1 px-2 md:py-1 md:px-3`
            : ` pt-${padding_mobile} pb-${padding_mobile} pl-${padding_mobile + 1.5} pr-${padding_mobile + 1.5} md:pt-${padding} md:pb-${padding} md:pl-${padding + 1.5} md:pr-${padding + 1.5}`;
          const inlineStyle = productData.container == 'product-info' 
            ? `style="text-transform: uppercase; letter-spacing: 1px;"`
            : `style="text-transform: uppercase; letter-spacing: 2px;"`;
          const inlineStyleIcon = `style="height: var(--font-size-scale); width: var(--font-size-scale); min-width: var(--font-size-scale);"`;
          const fontSize = productData.container == 'product-info' ? 'text-[11px]' : 'text-[12px]';
          
          content = `<div
              x-ref="content"
              class='x-badge-content ltr x-badge-text select-none inline-flex justify-center ${fontSize} ${sizeClass} items-center{css-opacity}{css-type} gap-2 ${tagClass}'
              ${inlineStyle}
            ><span class="icon-label empty:hidden" ${inlineStyleIcon}>${label.settings.icon || ''}</span><span class="leading-normal w-fit p-break-words">${badgeText}</span></div>`;
        } else if (label._isMetafieldBadge && canShow) {
          // Create individual metafield badge
          const badgeText = label._metafieldValue;
          const tagClass = 'p-tag p_tag-' + badgeText.toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
          
          const padding = (label.settings?.size || 2) / 2;
          const padding_mobile = (label.settings?.size_mobile || 2) / 2;
          const sizeClass = productData.container == 'product-info' 
            ? ` py-1 px-2 md:py-1 md:px-3`
            : ` pt-${padding_mobile} pb-${padding_mobile} pl-${padding_mobile + 1.5} pr-${padding_mobile + 1.5} md:pt-${padding} md:pb-${padding} md:pl-${padding + 1.5} md:pr-${padding + 1.5}`;
          const inlineStyle = productData.container == 'product-info' 
            ? `style="text-transform: uppercase; letter-spacing: 1px;"`
            : `style="text-transform: uppercase; letter-spacing: 2px;"`;
          const inlineStyleIcon = `style="height: var(--font-size-scale); width: var(--font-size-scale); min-width: var(--font-size-scale);"`;
          const fontSize = productData.container == 'product-info' ? 'text-[11px]' : 'text-[12px]';
          
          content = `<div
              x-ref="content"
              class='x-badge-content ltr x-badge-text select-none inline-flex justify-center ${fontSize} ${sizeClass} items-center{css-opacity}{css-type} gap-2 ${tagClass}'
              ${inlineStyle}
            ><span class="icon-label empty:hidden" ${inlineStyleIcon}>${label.settings.icon || ''}</span><span class="leading-normal w-fit p-break-words">${badgeText}</span></div>`;
        } else if (productData.metafield_label && canShow) {
          // Handle metafield badges (fallback for when no specific badge blocks are configured)
          const allMetafieldValues = [];
          Object.entries(productData.metafield_label).forEach(([key, value]) => {
            if (value && value.trim() !== '') {
              const values = value.split(',').map(v => v.trim()).filter(v => v !== '');
              allMetafieldValues.push(...values);
            }
          });
          
          if (allMetafieldValues.length > 0) {
            // Create multiple badge contents for comma-separated values
            const badgeContents = allMetafieldValues.map(badgeText => {
              const tagClass = 'p-tag p_tag-' + badgeText.toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
              
              const padding = (label.settings?.size || 2) / 2;
              const padding_mobile = (label.settings?.size_mobile || 2) / 2;
              const sizeClass = productData.container == 'product-info' 
                ? ` py-1 px-2 md:py-1 md:px-3`
                : ` pt-${padding_mobile} pb-${padding_mobile} pl-${padding_mobile + 1.5} pr-${padding_mobile + 1.5} md:pt-${padding} md:pb-${padding} md:pl-${padding + 1.5} md:pr-${padding + 1.5}`;
              const inlineStyle = productData.container == 'product-info' 
                ? `style="text-transform: uppercase; letter-spacing: 1px;"`
                : `style="text-transform: uppercase; letter-spacing: 2px;"`;
              const inlineStyleIcon = `style="height: var(--font-size-scale); width: var(--font-size-scale); min-width: var(--font-size-scale);"`;
              const fontSize = productData.container == 'product-info' ? 'text-[11px]' : 'text-[12px]';
              const marginClass = productData.container == 'product-info' ? 'mr-2' : '';
              
              return `<div
                  class='x-badge-content ltr x-badge-text select-none inline-flex justify-center ${fontSize} ${sizeClass} items-center{css-opacity}{css-type} gap-1 ${tagClass} ${marginClass}'
                  ${inlineStyle}
                ><span class="icon-label empty:hidden" ${inlineStyleIcon}>${label.settings.icon || ''}</span><span class="leading-normal w-fit p-break-words">${badgeText}</span></div>`;
            });
            
            content = badgeContents.join('');
          }
        } else if (label.settings.content && canShow) {
          let qty = (productData.inventory_management.length < 1 || productData.qty < 0) ? '' : productData.qty;
          let saleAmount = productData.sale_amount.includes('-') ? '' : productData.sale_amount;
          let countDown = label.settings.schedule_enabled ? '<span x-intersect.once="$nextTick(() => { if (typeof rePosition !== `undefined`) {rePosition()} });" class="x-badge-countdown-' + label.id + ' label-countdown empty:hidden"></span>' : '';
          let sale = Math.round((productData.compare_at_price - productData.price) * 100 / productData.compare_at_price);
          sale = sale == 100 ? 99 : sale;
          sale = sale > 0 ? sale + '%' : '';

          content = label.settings.content.replace(/{sale}/gi, sale)
                      .replace(/{sale_amount}/gi, saleAmount)
                      .replace(/{qty}/gi, qty)
                      .replace(/{price}/gi, productData.price_with_currency)
                      .replace(/{count_down}/gi, countDown);

          if (productData.metafield_label) {
            Object.entries(productData.metafield_label).forEach(([key, value]) => {
              content = content.replace(`{${key}}`, value);
            });
          }
          const padding = (label.settings?.size || 2) / 2;
          const padding_mobile = (label.settings?.size_mobile || 2) / 2;
          const sizeClass = ` pt-${padding_mobile} pb-${padding_mobile} pl-${padding_mobile + 1.5} pr-${padding_mobile + 1.5} md:pt-${padding} md:pb-${padding} md:pl-${padding + 1.5} md:pr-${padding + 1.5}`;
          const inlineStyle = `style="text-transform: uppercase; letter-spacing: 2px;"`;
          const inlineStyleIcon = `style="height: var(--font-size-scale); width: var(--font-size-scale); min-width: var(--font-size-scale);"`;
          content = content.length > 0
            ? `<div
                x-ref="content"
                class='x-badge-content ltr x-badge-text select-none inline-flex justify-center text-[12px] ${sizeClass} items-center{css-opacity}{css-type} gap-2 p-tag'
                ${inlineStyle}
              ><span class="icon-label empty:hidden" ${inlineStyleIcon}>${label.settings.icon}</span><span class="leading-normal w-fit p-break-words">${content}</span></div>` : false;

          if (countDown.length > 0 && label.settings.schedule_enabled) {
            Alpine.store('xHelper').countdown(label.settings, function(canShow, seconds, minutes, hours, days) {
              let container = el.container ? el.container : el;
              const countdownElements = container.getElementsByClassName('x-badge-countdown-' + label.id);

              if (!canShow) {
                for (let i = 0;i < countdownElements.length;i++) {
                  countdownElements[i].innerHTML = '';
                }
                return;
              }

              days = days > 0 ? days + "D&nbsp;&nbsp;&nbsp;" : "";
              hours = hours == 0 && days.length == 0 ? "" : hours + " : ";
              const timeLeft = days + hours + minutes + " : " + seconds;

              for (let i = 0;i < countdownElements.length;i++) {
                countdownElements[i].innerHTML = timeLeft;
              }
            });
          }
        }

        return content;
      },
      processTemplate(el, label, productData) {
        let template = '';
        const content = this.processContent(el, label, productData);
        if (content) {
          const cssOpacity = " opacity-" + label.settings.opacity;
          const cssPosition = productData.container == "card" ? "left: " + label.settings.horizontal_position + "%;" + " transform: translate(-"+ label.settings.horizontal_position+"%, -"+ label.settings.vertical_position+"%);"
            + " top: " + (label.settings.vertical_position) + "%;"
            : "";
          let cssType = '';
          if (label.settings.type == 'round') cssType = ' rounded-md';
          if (label.settings.type == 'rounded-full') cssType = ' rounded-full';

          let containerCssClass = productData.container == "card" ? " absolute w-max" : "";
          containerCssClass += label.settings.horizontal_position > 50 ? " text-end" : " text-start";
          const previewShowCondition = productData.isXBadgesPreview ? `x-show="$store.xBadges.previewActiveBlock == '{label-id}'"` : '';
          const imgClass = label.settings.image ? ' label-img' : '';

          template = this.getLableTemplate(productData.container, label.settings.position);
          
          template = template.replace('{preview-show-condition}', previewShowCondition)
            .replace('{content}', content)
            .replace('{css-opacity}', cssOpacity)
            .replace('{css-position}', cssPosition)
            .replace('{css-type}', cssType)
            .replace('{container-css-class}', containerCssClass)
            .replace('{container-img-class}', imgClass)
            .replace(/{label-id}/gi, label.id);
        }
        return template;
      },
      getLableTemplate(container, position) {
        if (container == 'product-info') {
          return this.productDetailTemplate;
        } else if (position == 'custom') {
          return this.customPositionTemplate;
        } else if (position == 'below-image' || position == 'bottom-card' || position == 'next-price') {
          return this.outSideImageTemplate.replace('{queryEL}', position);
        }

        return this.fixedPositionTemplate;
      },
      canShow(label, productData) {
        // Always show In Stock badges regardless of other rules
        if (label._isInStockBadge) {
          return true;
        }
        
        if (productData.isXBadgesPreview) {
          return true;
        }

        if (productData.container == 'card' && !label.settings.show_on_product_card) {
          return false;
        }

        if (productData.container == 'product-info' && !label.settings.show_on_product_page) {
          return false;
        }

        if (label.type == "sale-label") {
          // Show sale labels if there's an actual sale OR if the label uses metafields
          if (productData.compare_at_price > productData.price) {
            return true;
          }
          // Check if label content uses metafields
          if (label.settings.content && productData.metafield_label) {
            const metafieldKeys = Object.keys(productData.metafield_label);
            
            const hasMetafieldPlaceholders = metafieldKeys.some(key => {
              const placeholder = `{${key}}`;
              return label.settings.content.includes(placeholder);
            });
            
            if (hasMetafieldPlaceholders) {
              return true;
            }
          }
        }

        // Hide text labels with sale-related content when there's no actual sale
        if (label.type == "text-label" && label.settings.content) {
          const labelContent = label.settings.content.toLowerCase();
          const hasSaleWords = labelContent.includes('sale') || 
                              labelContent.includes('off') || 
                              labelContent.includes('discount') ||
                              labelContent.includes('%');
          
          if (hasSaleWords && productData.compare_at_price <= productData.price) {
            return false;
          }
        }

        if (label.type == "sold-out-label" && !productData.available) {
          return true;
        }
        
        if (label.type == "preorder-label" ) {
          if (productData.can_show_preorder && productData.available) {
            return true;
          } else {
            return false;
          }
        }
        
        if (label.type == "new-label" ) {
          if (label.settings.day_since == 'creation_date' && label.settings.number_show < productData.diff_day_create) {
            return false;
          } else if (label.settings.day_since == 'activation_date' && label.settings.number_show < productData.diff_day_publish) {
            return false;
          }
        }

        if (label.settings.schedule_enabled) {
          let endDate = new Date(
            label.settings.end_year,
            label.settings.end_month - 1,
            label.settings.end_day,
            label.settings.end_hour,
            label.settings.end_minute
          );
          label.endTime = endDate.getTime()
            + (-1 * label.settings.timezone * 60 - endDate.getTimezoneOffset()) * 60 * 1000;
   
          let startDate = new Date(
            label.settings.start_year,
            label.settings.start_month - 1,
            label.settings.start_day,
            label.settings.start_hour,
            label.settings.start_minute
          );
          label.startTime = startDate.getTime()
            + (-1 * label.settings.timezone * 60 - startDate.getTimezoneOffset()) * 60 * 1000;

          let now = new Date().getTime();
          if (label.endTime < now) {
            return false;
          }

          if (label.startTime > now) {
            return false;
          }
        }
        
        if (label.settings.applied_products.includes(productData.product_id)) {
          return true;
        }

        for(let i=0;i<label.settings.applied_collections.length;i++) {
          if (productData.collections.includes(label.settings.applied_collections[i])) {
            return true;
          }
        }

        // Check if badge uses metafields and should show regardless of targeting
        if (label.settings.content && productData.metafield_label) {
          const metafieldKeys = Object.keys(productData.metafield_label);
          
          // Check if badge content uses any metafield placeholders
          const hasMetafieldPlaceholders = metafieldKeys.some(key => {
            const placeholder = `{${key}}`;
            return label.settings.content.includes(placeholder);
          });
          
          if (hasMetafieldPlaceholders) {
            return true;
          }
          
          // Also show badges if they have non-empty metafield values
          const hasNonEmptyMetafields = metafieldKeys.some(key => {
            const value = productData.metafield_label[key];
            return value && value.trim() !== '';
          });
          
          if (hasNonEmptyMetafields && label.settings.applied_products.length == 0 && label.settings.applied_collections.length == 0) {
            return true;
          }
        }

        if (label.type != "sale-label"
          && label.type != "sold-out-label"
          && label.settings.applied_products.length == 0
          && label.settings.applied_collections.length == 0) {
          return true;
        }

        return false;
      },
      shouldApplyBadgeToVariant(label, variant) {
        // First check if the badge should show for this variant using the existing canShow logic
        if (!this.canShow(label, variant)) {
          return false;
        }

        // Check if the badge is applied to a specific product
        if (label.settings.applied_products && label.settings.applied_products.length > 0) {
          if (!label.settings.applied_products.includes(variant.product_id)) {
            return false;
          }
        }

        // Check if the badge is applied to a specific collection
        if (label.settings.applied_collections && label.settings.applied_collections.length > 0) {
          let isCollectionApplied = false;
          for (let i = 0; i < label.settings.applied_collections.length; i++) {
            if (variant.collections.includes(label.settings.applied_collections[i])) {
              isCollectionApplied = true;
              break;
            }
          }
          if (!isCollectionApplied) {
            return false;
          }
        }

        // Check if the badge is applied to a specific variant
        if (label.settings.applied_variants && label.settings.applied_variants.length > 0) {
          if (!label.settings.applied_variants.includes(variant.variant_id)) {
            return false;
          }
        }

        // Check if the badge is applied to a specific product type
        if (label.settings.applied_product_types && label.settings.applied_product_types.length > 0) {
          if (!label.settings.applied_product_types.includes(variant.product_type)) {
            return false;
          }
        }

        // Check if the badge is applied to a specific vendor
        if (label.settings.applied_vendors && label.settings.applied_vendors.length > 0) {
          if (!label.settings.applied_vendors.includes(variant.vendor)) {
            return false;
          }
        }

        // Check if the badge is applied to a specific tag
        if (label.settings.applied_tags && label.settings.applied_tags.length > 0) {
          let isTagApplied = false;
          for (let i = 0; i < label.settings.applied_tags.length; i++) {
            if (variant.tags.includes(label.settings.applied_tags[i])) {
              isTagApplied = true;
              break;
            }
          }
          if (!isTagApplied) {
            return false;
          }
        }

        // Check if the badge is applied to a specific option
        if (label.settings.applied_options && label.settings.applied_options.length > 0) {
          let isOptionApplied = false;
          for (let i = 0; i < label.settings.applied_options.length; i++) {
            if (variant.options.includes(label.settings.applied_options[i])) {
              isOptionApplied = true;
              break;
            }
          }
          if (!isOptionApplied) {
            return false;
          }
        }

        // Check if the badge is applied to a specific option value
        if (label.settings.applied_option_values && label.settings.applied_option_values.length > 0) {
          let isOptionValueApplied = false;
          for (let i = 0; i < label.settings.applied_option_values.length; i++) {
            if (variant.option_values.includes(label.settings.applied_option_values[i])) {
              isOptionValueApplied = true;
              break;
            }
          }
          if (!isOptionValueApplied) {
            return false;
          }
        }

        return true;
      }
    });
  });
});
